import { FiltersDataModel } from "../components/constants/GlobalStoreConstants";
import { isGuid } from "../Helpers";

interface FiltersTemplateType {
  filterType: "checkbox" | "date" | "amount";
  title: string;
  mappingKey: string,
  metadataKey: string,
  selectedIndex?: number;
  options: any[];
}

const isOptionClicked = (option, data) => {
  if (option?.id && data.optionId) {
    return option?.id === data.optionId;
  }

  if ((!option?.id || !data.optionId) && option.label && data.label) {
    return option.label === data.label;
  }

  return false;
};

export const getUpdatedCheckedFilters = (
  filtersList: FiltersTemplateType[],
  menuTitle,
  data,
  subgroup
) => {
  return filtersList.map((filter) => {
    if (filter?.title === menuTitle && filter?.options) {
      return {
        ...filter,
        options: filter?.options?.map((option) => {
          if (subgroup) {
            if (option?.label === subgroup) {
              return {
                ...option,
                subgroupOptions: option.subgroupOptions.map((so) => {
                  if (isOptionClicked(so, data)) {
                    return {
                      ...so,
                      value: data?.checked,
                    };
                  }
                  return so;
                }),
              };
            }
            return option;
          }
          else {
            if (isOptionClicked(option, data)) {
              return {
                ...option,
                value: data?.checked,
              };
            }
            return option;
          }
        }),
      };
    }
    return filter;
  });
};

export const getUpdatedOnCollapseFilters = (filtersList: FiltersTemplateType[], menuTitle, subgroup) => {
  return filtersList.map((filter) => {
    if (filter?.title === menuTitle && filter?.options) {
      return {
        ...filter,
        options: filter?.options?.map((option) => {
          if (option?.label === subgroup) {
            return {
              ...option,
              isCollapsed: !option.isCollapsed,
            };
          }
          return option;
        }),
      };
    }
    return filter;
  });
};

export const getUpdatedDateFilters = (filtersList: FiltersTemplateType[], menuTitle, selectedValue, value, id) => {
  return filtersList.map((filter) => {
    if (filter?.title === menuTitle && filter?.options) {
      return {
        ...filter,
        options: filter.options.map((option) => {
          if (option?.value === selectedValue && option?.fields) {
            return {
              ...option,
              fields: option?.fields?.map((of) => {
                if (of?.id === id) {
                  return { ...of, value };
                }
                return of;
              }),
            };
          }
          return option;
        }),
      };
    }
    return filter;
  });
};

export const getUpdatedSelectedDateFilters = (filtersList: FiltersTemplateType[], menuTitle, selectedValue, selectedIndex) => {
  return filtersList.map((filter) => {
    if (filter?.title === menuTitle) {
      return {
        ...filter,
        value: selectedValue,
        selectedIndex,
      };
    }
    return filter;
  });
};

export const getUpdatedClearedMenuFilters = (filtersList, filtersListInitial, menuTitle) => {
  const initialMenuValues = filtersListInitial.find(
    (f) => f.title === menuTitle
  );
  return filtersList.map((filter) => {
    if (filter?.title === menuTitle && initialMenuValues) {
      return initialMenuValues;
    }
    return filter;
  });
};

export const getFilterMenuTitle = (filtersList, title) => {
  const activeFilters: any[] = [];
  let formattedTitle = title;
  let isFilterActive = false;
  filtersList.map((f) => {
    if (f.title === title && f.options) {
      f.options.map((o, i) => {
        if (f.filterType === "checkbox") {
          if (o?.subgroupOptions) {
            o.subgroupOptions.map((so) => {
              if (so.value && so.label) {
                activeFilters.push(so.label);
              }
            });
          }
          else {
            if (o.value && o.label) {
              activeFilters.push(o.label);
            }
          }
        }
        if (f.filterType === "date" || f.filterType === "amount") {
          if (
            f.options[f.selectedIndex].fields[0].value &&
            f.selectedIndex === i
          ) {
            if (f.options[f.selectedIndex].fields[1]) {
              if (f.options[f.selectedIndex].fields[1].value) {
                activeFilters.push(f.options[f.selectedIndex].text);
              }
            }
            else {
              activeFilters.push(f.options[f.selectedIndex].text);
            }
          }
        }
      });
    }
  });
  if (activeFilters.length === 1) {
    formattedTitle = activeFilters[0];
    isFilterActive = true;
  }
  if (activeFilters.length > 1) {
    formattedTitle = `${activeFilters[0]} (+${activeFilters.length - 1})`;
    isFilterActive = true;
  }
  return { formattedTitle, isFilterActive };
};

export const getSelectedFilterValues = (filtersList: FiltersTemplateType[]) => {
  const result = [] as any[];
  filtersList.map((filter) => {
    if (filter.filterType === "checkbox") {
      const allChecked = [] as string[];
      filter?.options?.map((o) => {
        if (o.subgroupOptions) {
          o.subgroupOptions.map((so) => {
            if (so.value) {
              allChecked.push(so.id || so.label);
            }
          });
        }
        else {
          if (o.value) {
            allChecked.push(o.id || o.label);
          }
        }
      });

      if (allChecked.length > 0) {
        result.push({
          title: filter.title,
          mappingKey: filter.mappingKey,
          metadataKey: filter.metadataKey,
          filterType: "checkbox",
          activeFilters: allChecked,
        });
      }
    }
    if (filter.filterType === "amount" || filter.filterType === "date") {
      const optionFields = (filter.selectedIndex || filter.selectedIndex === 0) ? filter?.options[filter.selectedIndex]?.fields : [];
      const optionValue = (filter.selectedIndex || filter.selectedIndex === 0) ? filter?.options[filter.selectedIndex]?.value : "";
      if (optionFields[0]?.value && optionValue) {
        if (optionFields[1] && !optionFields[1]?.value) {
          return;
        }
        result.push({
          title: filter.title,
          mappingKey: filter.mappingKey,
          metadataKey: filter.metadataKey,
          filterType: filter.filterType,
          selectedValue: optionValue,
          activeFilters: [
            {
              label: optionValue,
              values: optionFields.map((field) => {
                return { label: field.label, value: field.value };
              })
            }
          ]
        });
      }
    }
  });

  return result;
};

export const validateAmount = (activeAmountFilter, matchValue) => {
  let isMatch = false;
  const filterOptionLabel = activeAmountFilter.label;
  const filterOptionLabelLower = filterOptionLabel?.toLowerCase();
  const filterOptionValues = activeAmountFilter.values;
  const matchFloatValue = parseFloat(matchValue);
  const floatOptionValue = parseFloat(filterOptionValues[0].value);
  if (matchValue && filterOptionValues[0].value) {
    if (filterOptionLabelLower === "equals") {
      isMatch = floatOptionValue === matchFloatValue;
    }

    if (filterOptionLabelLower === "does not equal") {
      isMatch = floatOptionValue !== matchFloatValue;
    }

    if (filterOptionLabelLower === "less than") {
      isMatch = floatOptionValue >= matchFloatValue;
    }

    if (filterOptionLabelLower === "greater than") {
      isMatch = floatOptionValue <= matchFloatValue;
    }

    if (filterOptionLabelLower === "between" && filterOptionValues[1].value) {
      isMatch = floatOptionValue < matchFloatValue && matchFloatValue < parseFloat(filterOptionValues[1].value);
    }

    if (filterOptionLabelLower === "under and over" && filterOptionValues[1].value) {
      isMatch = floatOptionValue > matchFloatValue || matchFloatValue > parseFloat(filterOptionValues[1].value);
    }
  }

  return isMatch;
};

export const validateDate = (activeAmountFilter, matchValue) => {
  let isMatch = false;
  const filterOptionLabel = activeAmountFilter.label;
  const filterOptionLabelLower = filterOptionLabel?.toLowerCase();
  const filterOptionValues = activeAmountFilter.values;
  const matchValueString = matchValue?.includes("T") ? matchValue.split("T")[0] : matchValue;
  const matchValueMilliseconds = new Date(matchValueString).getTime();
  const optionValueMilliseconds = new Date(filterOptionValues[0].value).getTime();
  if (matchValue) {
    if (filterOptionLabelLower === "equals") {
      isMatch = optionValueMilliseconds === matchValueMilliseconds;
    }

    if (filterOptionLabelLower === "does not equal") {
      isMatch = optionValueMilliseconds !== matchValueMilliseconds;
    }

    if (filterOptionLabelLower === "before") {
      isMatch = optionValueMilliseconds > matchValueMilliseconds;
    }

    if (filterOptionLabelLower === "after") {
      isMatch = optionValueMilliseconds < matchValueMilliseconds;
    }

    if (filterOptionLabelLower === "between") {
      isMatch = optionValueMilliseconds < matchValueMilliseconds && matchValueMilliseconds < new Date(filterOptionValues[1].value).getTime();
    }

    if (filterOptionLabelLower === "before and after") {
      isMatch = optionValueMilliseconds > matchValueMilliseconds || matchValueMilliseconds > new Date(filterOptionValues[1].value).getTime();
    }
  }

  return isMatch;
};

export const globalFilteredData = (data, activeFiltersList, metadata) => {
  if (activeFiltersList && activeFiltersList.length !== 0) {
    const activeFiltersObj = {};
    activeFiltersList?.map(({ mappingKey, metadataKey, filterType, activeFilters }) => {
      const activeMappingKey = metadataKey || mappingKey;
      activeFiltersObj[activeMappingKey] = { filterType, activeFilters };
    });

    const metadataTranslatorIdToName = {};
    const metadataTranslatorNameToId = {};
    Object.entries(metadata || {}).map(([key, value]: any[]) => {
      if (Array.isArray(value)) {
        metadataTranslatorIdToName[key] = value?.reduce((obj, next) => {
          return { ...obj, [next.id]: next.name };
        }, {}) || {};
        metadataTranslatorNameToId[key] = value?.reduce((obj, next) => {
          return { ...obj, [next.name]: next.id };
        }, {}) || {};
      }
    });

    return data.filter(d => {
      return activeFiltersList?.some(({ mappingKey, metadataKey, filterType }) => {
        const activeMappingKey = metadataKey || mappingKey;
        const activeFilters = activeFiltersObj[activeMappingKey]?.activeFilters;
        const value = d[metadataKey] || d[mappingKey];
        const idToName = metadataTranslatorIdToName[activeMappingKey];
        const nameToId = metadataTranslatorNameToId[activeMappingKey];

        if (filterType === "checkbox") {
          if (Array.isArray(value)) {
            const translatedValues = [] as any[];
            if (Array.isArray(value) && value[0] && isGuid(value[0])) {
              value.map(guid => {
                if (idToName && idToName[guid]) {
                  translatedValues.push(idToName[guid]);
                }
              });
            }
            return activeFilters.some(f => value.includes(f) || translatedValues.includes(f));
          }
          else {
            if (value && isGuid(value)) {
              if (isGuid(activeFilters[0])) {
                return activeFilters.includes(value);
              }

              if (activeFilters && activeFilters[0] && !isGuid(activeFilters[0]) && idToName) {
                return activeFilters.includes(idToName[value]);
              }
            }
            else {
              if (!isGuid(value) && isGuid(activeFilters[0]) && nameToId) {
                return activeFilters.some(af => {
                  return af === nameToId[value];
                });
              }

              return activeFilters.includes(value);
            }
          }
        }

        if (filterType === "amount") {
          return validateAmount(activeFilters[0], value);
        }

        if (filterType === "date") {
          return validateDate(activeFilters[0], value);
        }

        return false;
      });
    });
  }

  return data;
};

export const getFormattedFilterOptions = (metaDataOptions, type) => {
  if (type === "checkbox") {
    const checkboxOptions = [] as any[];
    const subGroups = {};
    const optionsFinal = [] as any[];
    metaDataOptions.map(option => {
      const formattedOption = { label: option.name, id: option.id, value: false };
      if (option.role || option.subGroup) {
        const subGroupName = option.role || option.subGroup;
        if (subGroups[subGroupName]) {
          subGroups[subGroupName].push(formattedOption);
        }
        else {
          subGroups[subGroupName] = [formattedOption];
        }
      }
      else {
        checkboxOptions.push(formattedOption);
      }
    });

    if (Object.keys(subGroups).length !== 0) {
      Object.entries(subGroups).map(([subGroupName, options]) => {
        optionsFinal.push({ label: subGroupName, value: false, isCollapsed: false, subgroupOptions: options });
      });
    }

    return [...optionsFinal, ...checkboxOptions];
  }
  return [];
};

export const getNoSpaceLower = (string) => {
  if (string && typeof string === "string") {
    return string?.replace(/\s/g, "").toLowerCase();
  }
  else {
    return string;
  }
};

export const getPopulatedPortalFilters = (metaData, hiddenFilters = [] as any[]) => {
  const hiddenFiltersLower = hiddenFilters.map(af => getNoSpaceLower(af));
  return FiltersDataModel.map(filter => {
    const isHidden = hiddenFilters.length > 0 && hiddenFiltersLower.includes(getNoSpaceLower(filter.title));
    const metadataKey: any = filter.metadataKey || filter.mappingKey;
    if (metaData && metaData[metadataKey]) {
      return {
        ...filter,
        isHidden,
        options: getFormattedFilterOptions(metaData[metadataKey], filter.filterType)
      };
    }
    return {
      ...filter,
      isHidden
    };
  });
};